<!-- Sidebar -->


<div class="filter-layout">
  <div class="fl-header">
    <div>
    <p class="f-14 font-weight-600 mb-0">Filters</p>
    <span class="f-12 text-9696" *ngIf="searchCandidates?.length > 0">Based on your search results</span>
    </div>

    <div class="d-flex align-items-center">
      <div>
          <a data-testid="auto-app-pipeline-filter-a-1" class="f-12 text-webbtree-green pointer mr-2" (click)="resetFilter('reset')">Reset All</a>
        <button data-testid="auto-app-pipeline-filter-button-1" class="hire-btn-secondary mr-3" (click)="dismiss()">Cancel</button>
        <button data-testid="auto-app-pipeline-filter-button-2" class="hire-btn-primary" (click)="applyFilter()">Apply</button>
      </div>
    </div>
  </div>
  <div class="fl-container">
    <form [formGroup]="candidateFilterForm">
      <div class="content-body">
        <div class="row">
          <div class="col-6" *ngIf="shouldShowFilter(filterNames.NAME)">
              <div id="collapseOne">
                <label for="candidatename" class="label-style">Candidate Names</label>
                <div class="position-relative mb-3">
                  <input data-testid="auto-app-pipeline-filter-input-1" class="wc-form-control" placeholder="Enter Candidate Name" #candidatenameInput [matAutocomplete]="candidatename"
                    (input)="getTypeaheads('candidatename', $event.target.value)" formControlName="candidatename" (click)="getTypeaheads('candidatename','')">
                    <div *ngIf="showCandidateNameLoader" class="spinner-border position-absolute text-webbtree-green" style="top:9px; right: 9px; background-color: #fff;" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  <mat-autocomplete #candidatename="matAutocomplete"
                    (optionSelected)="selectOption($event.option.value, 'candidatename')">
                    <mat-option *ngFor="let name of candidateNameRes" [value]="name">{{name.fullname | titlecase}} <span>
                        </span>
                    </mat-option>
                  </mat-autocomplete>

                </div>
                <div>
                  <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let name of selectedName">
                    <div class="d-flex">
                      <span style="display: grid;">
                        <span class="text-truncate" title="{{name?.fullname}}">
                          {{name?.fullname | titlecase }}
                        </span>
                      </span>

                      <span class="ml-2 pointer " (click)="unselect(name, 'candidate')">
                        <i class="fal fa-times"></i></span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-6" *ngIf="shouldShowFilter(filterNames.JOB_TITLE)">
              <div id="collapseTwo" >
                <label for="currentjobtitle" class="label-style"> Current Job Title</label>
                <div class="position-relative mb-3">
                  <input data-testid="auto-app-pipeline-filter-input-2" class="wc-form-control" placeholder="Enter Current Job Title"  [matAutocomplete]="current_jobtitle"
                    (input)="getTypeaheads('jobtitle', $event.target.value)" formControlName="currentjobtitle" (click)="getTypeaheads('jobtitle','')">
                    <div *ngIf="showJobtitleLoader" class="spinner-border position-absolute text-webbtree-green" style="top:9px; right: 9px; background-color: #fff;" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  <mat-autocomplete #current_jobtitle="matAutocomplete"
                    (optionSelected)="selectOption($event.option.value, 'jobtitle')">
                    <mat-option *ngFor="let job of jobTitleRes" [value]="job">{{job?.jobtitle | titlecase}} ({{job?.count}}) <span>
                        </span></mat-option>
                  </mat-autocomplete>

                </div>
                <div>
                  <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let jobnamechip of selectedJobTitle">
                    <div class="d-flex">
                      <span style="display: grid;">
                        <span class="text-truncate" title="{{jobnamechip?.jobtitle}}">
                          {{jobnamechip?.jobtitle | titlecase}}
                        </span>
                      </span>

                      <span class="ml-2 pointer " (click)="unselect(jobnamechip, 'jobtitle')">
                        <i class="fal fa-times"></i></span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            </div>

            <!-- Current company -->
            <div class="row">
              <div class="col-6" *ngIf="shouldShowFilter(filterNames.COMPANY)">
                <div id="collapseThree">
                  <label for="currentcompany" class="label-style">Current Company</label>
                  <div class="position-relative mb-3">
                    <input data-testid="auto-app-pipeline-filter-input-3" class="wc-form-control" name="currentcompany" placeholder="Enter Current Company" [matAutocomplete]="current_company"
                      (input)="getTypeaheads('company', $event.target.value)" formControlName="currentcompany" (click)="getTypeaheads('company','')">
                      <div *ngIf="showCompanyLoader" class="spinner-border position-absolute text-webbtree-green" style="top:9px; right: 9px; background-color: #fff;" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    <mat-autocomplete #current_company="matAutocomplete"
                      (optionSelected)="selectOption($event.option.value, 'company')">
                      <mat-option *ngFor="let company of companylist" [value]="company">{{company?.companyname | titlecase}} ({{company?.count}}) <span>
                          </span></mat-option>
                    </mat-autocomplete>

                  </div>
                  <div>
                    <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let chip of selectedcompany">
                      <div class="d-flex">
                        <span style="display: grid;">
                          <span class="text-truncate" title="{{chip?.companyname}}">
                            {{chip?.companyname | titlecase}}
                          </span>
                        </span>

                        <span class="ml-2 pointer " (click)="unselect(chip, 'company')">
                          <i class="fal fa-times"></i></span>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            <div class="col-6" *ngIf="shouldShowFilter(filterNames.LOCATION)">
              <div id="collapseFour">
                <label for="currentlocation" class="label-style">Current Location</label>
                <div class="position-relative mb-3">
                  <input data-testid="auto-app-pipeline-filter-input-4" class="wc-form-control" name="currentlocation" placeholder="Enter Current Location"  [matAutocomplete]="current_location"
                    (input)="getTypeaheads('location', $event.target.value)" formControlName="currentlocation" (click)="getTypeaheads('location','')">
                    <div *ngIf="showLocationLoader" class="spinner-border position-absolute text-webbtree-green" style="top:9px; right: 9px; background-color: #fff;" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  <mat-autocomplete #current_location="matAutocomplete"
                    (optionSelected)="selectOption($event.option.value, 'location')">
                    <mat-option *ngFor="let location of locationRes" [value]="location">{{location?.locationname | titlecase}}({{location?.count}}) <span>
                        </span></mat-option>
                  </mat-autocomplete>

                </div>
                <div>
                  <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let location of selectedLocation">
                    <div class="d-flex">
                      <span style="display: grid;">
                        <span class="text-truncate" title="{{location?.locationname}}">
                          {{location?.locationname | titlecase}}
                        </span>
                      </span>

                      <span class="ml-2 pointer " (click)="unselect(location, 'location')">
                        <i class="fal fa-times"></i></span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            </div>
            <div class="row">
              <div class="col-6" *ngIf="shouldShowFilter(filterNames.CONTACT_REQUESTED)">
              <div id="collapseSix">
                <div class="position-relative mb-3">
                  <label class="label-style"> Contact Requested</label>
                <p-multiSelect [options]="multiSelectOptions" formControlName="contactRequestControl"
            (onChange)="toggleOption($event)" placeholder="Select Contact Request" optionLabel="name" [selectedItemsLabel]="'Select Contact Request'" [display]="'chip'"
            [filter]="false">

            <ng-template let-value pTemplate="selectedItems">
              <span *ngIf="value?.length">
                {{ value.length }} selected
              </span>
            </ng-template>

            <ng-template pTemplate="header">
              <div class="flex align-items-center" style="position: absolute!important; left: 36px!important;">
                <div class="p-multiselect-header-checkbox">
                  <span class="p-checkbox-label">All</span>
                </div>
              </div>
            </ng-template>

            <ng-template let-cs pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ cs }}</div>
              </div>
            </ng-template>

          </p-multiSelect>
                <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let request of selectedContactRequest">
                    <div class="d-flex">
                      <span style="display: grid;">
                        <span class="text-truncate" title="{{request}}">
                          {{request}}
                        </span>
                      </span>

                      <span class="ml-2 pointer " (click)="unselect(request, 'selectedContactRequest')">
                        <i class="fal fa-times"></i></span>
                    </div>
                  </span>



                    </div>
                </div>
            </div>
              <div class="col-6" *ngIf="shouldShowFilter(filterNames.CONTACT_STATUS)">
              <div class="card bt">
              <div id="collapseSeven">
                <div class="position-relative mb-3">
                  <label class="label-style">Contact Status Filter</label>
                        <div class="position-relative mb-3 mb-2 advsearchpinput">

            <p-multiSelect [options]="contactStatusFilterOptions" formControlName="contactStatusControl"
            (onChange)="toggleStatus($event)" placeholder="Select Contact Status" optionLabel="name" [selectedItemsLabel]="'Select Contact Status'" [display]="'chip'"
            [filter]="false">

            <ng-template let-value pTemplate="selectedItems">
              <span *ngIf="value?.length">
                {{ value.length }} selected
              </span>
            </ng-template>

            <ng-template pTemplate="header">
              <div class="flex align-items-center" style="position: absolute!important; left: 36px!important;">
                  <div class="p-multiselect-header-checkbox">
                  <span class="p-checkbox-label">All</span>
                </div>
              </div>
            </ng-template>

            <ng-template let-cs pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ cs.key }}</div>
              </div>
            </ng-template>

          </p-multiSelect>
                <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let request of selectedStatus">
                    <div class="d-flex">
                      <span style="display: grid;">
                        <span class="text-truncate" title="{{request}}">
                          {{request.key}}
                        </span>
                      </span>

                      <span class="ml-2 pointer " (click)="unselect(request, 'contactstatus')">
                        <i class="fal fa-times"></i></span>
                    </div>
                  </span>

                          <!-- <div class="multi-select-container">
                            <div *ngFor="let status of contactStatusFilterOptions" class="multi-select-option">

                              <div>
                                <label class="wc-checkbox mb-0">
                                  <input data-testid="auto-app-pipeline-filter-input-5"  type="checkbox"
                                  [checked]="selectedStatus.includes(status?.value)"
                                  (change)="toggleStatus(status?.value)" id="mycheck" name="mycheck">
                                  <i class="fas fa-check" style="border-color: #2e93a1 ;"> </i>
                                </label>
                                {{ status?.key }}
                              </div>
                            </div>
                          </div> -->
                        </div>

                    </div>
                <div>

                </div>
              </div>
              </div>
              </div>
            </div>
     <div class="row">
          <div class="col-6" *ngIf="shouldShowFilter(filterNames.SOURCE)">
              <div id="collapseOne">
                <div class="position-relative mb-3">
                   <label for="candidatename" class="label-style">Candidate Source</label>
                   <p-multiSelect [options]="candidateSource" formControlName="candidateSourceControl"
            (onChange)="changePipelinedata($event, 'source')" placeholder="Select Candidate Source" optionLabel="name" [selectedItemsLabel]="'Select candidate source'" [display]="'chip'"
            [filter]="false">

            <ng-template let-value pTemplate="selectedItems">
              <span *ngIf="value?.length">
                {{ value.length }} selected
              </span>
            </ng-template>

            <ng-template pTemplate="header">
              <div class="flex align-items-center" style="position: absolute!important; left: 36px!important;">
               <div class="p-multiselect-header-checkbox">
                  <span class="p-checkbox-label">All</span>
                </div>
              </div>
            </ng-template>

            <ng-template let-cs pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ cs?.key }}</div>
              </div>
            </ng-template>

          </p-multiSelect>
                <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let request of selectedSource">
                    <div class="d-flex">
                      <span style="display: grid;">
                        <span class="text-truncate" title="{{request.key}}">
                          {{request?.key}}
                        </span>
                      </span>

                      <span class="ml-2 pointer " (click)="unselect(request, 'source')">
                        <i class="fal fa-times"></i></span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-6" *ngIf="shouldShowFilter(filterNames.STAGE)">
              <div id="collapseTwo" >
                <label for="currentjobtitle" class="label-style"> Current Stage</label>
                <div class="position-relative mb-3">
                  <input data-testid="auto-app-pipeline-filter-input-6" class="wc-form-control" placeholder="Enter Current Stage"  [matAutocomplete]="current_stage"
                    (input)="getTypeaheads('stage', $event.target.value)" formControlName="currentstage" (click)="getTypeaheads('stage','')">
                    <div *ngIf="showJobtitleLoader" class="spinner-border position-absolute text-webbtree-green" style="top:9px; right: 9px; background-color: #fff;" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  <mat-autocomplete #current_stage="matAutocomplete"
                    (optionSelected)="selectOption($event.option.value, 'stage')">
                    <mat-option *ngFor="let stage of filteredStageList" [value]="stage">{{stage}} <span>
                        </span></mat-option>
                  </mat-autocomplete>

                </div>
                <div>
                  <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let stage of selectedStage">
                    <div class="d-flex">
                      <span style="display: grid;">
                        <span class="text-truncate" title="{{stage}}">
                          {{stage}}
                        </span>
                      </span>

                      <span class="ml-2 pointer " (click)="unselect(stage, 'stage')">
                        <i class="fal fa-times"></i></span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            </div>
            <div class="row">
              <div class="col-6" *ngIf="shouldShowFilter(filterNames.TAGS)">
                <div id="collapseFive" >
                  <label for="tags" class="label-style">Tags</label>
                  <div class="position-relative mb-3">
                    <input data-testid="auto-app-pipeline-filter-input-7" class="wc-form-control" name="tags" placeholder="Enter Tags" [matAutocomplete]="tags_auto" formControlName="tags"
                      (input)="getTypeaheads('tags', $event.target.value)" (click)="getTypeaheads('tags','')">
                      <div *ngIf="showTagLoader" class="spinner-border position-absolute text-webbtree-green" style="top:9px; right: 9px; background-color: #fff;" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    <mat-autocomplete #tags_auto="matAutocomplete"
                      (optionSelected)="selectOption($event.option.value, 'tags')">
                      <mat-option *ngFor="let tag of taglist" [value]="tag">{{tag?.tagtext | titlecase}} <span>
                          </span></mat-option>
                    </mat-autocomplete>

                  </div>
                  <div>
                    <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let tags of selectedtags">
                      <div class="d-flex">
                        <span style="display: grid;">
                          <span class="text-truncate">
                            {{tags?.tagtext | titlecase}}
                          </span>
                        </span>

                        <span class="ml-2 pointer " (click)="unselect(tags, 'tags')">
                          <i class="fal fa-times"></i></span>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
      </div>
    </form>
  </div>
</div>
